import { Injectable, isDevMode, NgModule } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Translation, TranslocoLoader, TranslocoModule, provideTransloco } from '@jsverse/transloco';

@Injectable({ 
  providedIn: 'root' 
})
class TranslocoHttpLoader implements TranslocoLoader {
  
  constructor(
    protected readonly http: HttpClient
  ) {}

  public getTranslation(lang: string): Observable<any>{
    return this.http.get<Translation>(`/assets/i18n/${lang}.json`);
  }
}

@NgModule({
  exports: [ TranslocoModule ],
  providers: [
    provideTransloco({
      loader: TranslocoHttpLoader,
      config: {
        defaultLang: 'en',
        fallbackLang: 'en',
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
        flatten: {
          aot: !isDevMode()
        },
        missingHandler: {
          allowEmpty: true,
          useFallbackTranslation: true,
        },
        availableLangs: [
          'en',
          'id'
        ],
      }
    }),
  ]
})
export class TranslocoRootModule {}
